import { c as _c } from "react/compiler-runtime";
import type { DetailedHTMLProps, HTMLAttributes } from 'react';
import { ExpandableGridProvider, type ExpandableGridProviderProps } from '@/components/ExpandableGrid/ExpandableGridContext';
import { cn } from '@/lib/cn';
export interface ExpandableGridProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  options?: ExpandableGridProviderProps['options'];
}
export function ExpandableGrid(t0) {
  const $ = _c(14);
  let children;
  let className;
  let options;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      options,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = options;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    options = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn("grid md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== children || $[8] !== props || $[9] !== t1) {
    t2 = <div data-testid="expandable-grid" className={t1} {...props}>{children}</div>;
    $[7] = children;
    $[8] = props;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== options || $[12] !== t2) {
    t3 = <ExpandableGridProvider options={options}>{t2}</ExpandableGridProvider>;
    $[11] = options;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}